import ApiService from "../../Services/ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class MyIncomeService {
  static getWillReleaseData = async (params) => {
    let num, cursor, sort, progress;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }

    if (params.progress && params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    const instance = await ApiService();
    return instance.get(
      `/invoice/transaction/order?${num || ""}${progress || ""}${sort || ""}${
        cursor || ""
      }`
    );
  };

  static getHasReleaseData = async (params) => {
    let num, cursor, date_start, date_end, keyword;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }

    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    const instance = await ApiService();
    return instance.get(
      `/invoice/billing/order?${num || ""}${date_end || ""}${date_start || ""}${
        cursor || ""
      } ${keyword || ""}`
    );
  };

  static getReciveSaldoData = async (params) => {
    const instance = await ApiService();
    return instance.get(`/invoice/transaction/order/saldo`);
  };
  static getReciveTotalAmount = async (params) => {
    let cancel, completed;

    if (params.cancel && params.cancel !== "") {
      cancel = `&cancel=${params.cancel}`;
    }

    if (params.completed && params.completed !== "") {
      completed = `&completed=${params.completed}`;
    }

    const instance = await ApiService();
    return instance.get(`/invoice/billing/total_amount?${cancel || ""}${completed || ""}`);
  };

  static getMyRekening = async (params) => {
    const instance = await ApiService();
    return instance.get(`/tenant/${user.tenant.id}`);
  };
}
